import { useQuery } from '@apollo/client';
import { enqueueSnackbar } from 'notistack';

import { gql } from '../../generated';
import { currency } from '../../types/apolo-client-backend';

type CurrencyResponse = {
  currency: currency[];
};

const GET_ALL_CURRENCY = gql(/* GraphQL */ `
  query GetAllCurrency {
    currency {
      id
      icon
    }
  }
`);

type MerchantCurrencyResponse = {
  merchant_currency: { currency: currency }[];
};

const GET_MERCHANT_CURRENCY = gql(/* GraphQL */ `
  query GetMerchantCurrency {
    merchant_currency(order_by: { currency: { id: asc } }) {
      currency {
        id
        icon
      }
    }
  }
`);

export const useCurrency = (availableCurrency?: boolean) => {
  const { loading, data } = useQuery<MerchantCurrencyResponse | CurrencyResponse>(
    availableCurrency ? GET_MERCHANT_CURRENCY : GET_ALL_CURRENCY,
    {
      onError: (error) => {
        enqueueSnackbar(error.message, { variant: 'error' });
      },
    }
  );

  if (loading) {
    return {
      loading,
      data: data as CurrencyResponse,
    };
  }

  if (availableCurrency) {
    return {
      loading,
      data: {
        currency: (data as MerchantCurrencyResponse)?.merchant_currency.map(({ currency }) => currency),
      } as CurrencyResponse,
    };
  }

  return {
    loading,
    data: data as undefined,
  };
};
